export default __webpack_public_path__ + "static/media/tanium_logo.f7690ca9.svg";